export default __webpack_public_path__ + "static/106-min-min-ec0c08e747d618b35142cfc57664ace8.jpg";